<template>
	<v-container fluid class="pa-3">
    <v-row>
      <v-col cols="10">
        <v-row class="" align="center">

          <v-col cols="3">
            <v-text-field 
              class="f-l pa-0 ma-0 wid-100 input-hei-d" 
              v-model="searchWord" 
              outlined
              dense
              hide-details
              placeholder="검색어"
              background-color="white">
            </v-text-field>
          </v-col>
          <!-- <v-col cols="1">
            <v-btn 
              small 
              color="blue lighten-2" 
              class="white--text" 
              @click="searchBtnClicked"
              >검색
            </v-btn>
          </v-col> -->
        </v-row>
        
        <v-row>
          <v-col cols="12" class="">
            <v-data-table
              :headers="gridHeader"
              :items="gridList"
              class="elevation-1"
              :search="searchWord"
              @click:row="rowClicked"
              style="cursor: pointer"
            >
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="2">
        <v-card class="pt-3">
          <v-row class="pr-3 pl-3" dense>
            <v-col cols="12" class="pb-3"><h3>필터</h3></v-col>
            <v-col cols="12"><v-divider></v-divider></v-col>
          
            <v-col cols="12" class="pt-0 pb-0">
              <v-radio-group 
                v-model="$store.state.boardList.radioBoardType"
              >
                <template v-slot:label>
                  <div><span>게시판 유형으로</span></div>
                </template>
                <v-radio
                  label="모두"
                  value="모두"
                ></v-radio>
                <v-radio
                  v-for="(item, index) in boardTypeList"
                  :key="index"
                  :label="item.cmn_cd_nm"
                  :value="item.cmn_cd"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

	</v-container>
</template>
  
<script>
export default {
  data(){
    return {
      redrawCount : 0,  // 화면 다시 그리기
      // mberChkDialog: false,
      gridHeader: [
        { text: '게시판 유형', value: 'page_type_nm', width: "30%" },
        { text: '게시판 메뉴명', value: 'menu_nm', width: "70%" },
      ],
      // gridList: [],
      boardList: [],
      
      boardTypeList: [],

      searchWord: null,
    }
  },
  computed: {
    gridList() {
      return this.boardList.filter((e) => {
        return (this.$store.state.boardList.radioBoardType == "모두" || e.page_type == this.$store.state.boardList.radioBoardType);
      });
    }
  },
  created() {
    this.getBoardTypeList();
  },
  mounted(){
    this.getBoardList();
  },
  methods: {
    async getBoardTypeList() {
      const boardTypeList = await this.$getCmnCdList("page_type");
      this.boardTypeList = boardTypeList.filter((e) => {
        return (e.cmn_cd.includes("bbs") || e.cmn_cd === "scdul");
      });
      console.log("getBoardTypeList: ", boardTypeList, this.boardTypeList);
    },
    getBoardList() {
      const params = new FormData();

      this.$http.post("/admin/getBoardList", params).then((res) => {
        console.log("res.data.result:", res.data.result);
        // this.gridList = res.data.result.prodList;
        this.boardList = res.data.result.boardList;
        // this.filterList();
      }).catch(
        function (error) {
          console.log(error);
        }
      );
    },
    rowClicked(event) {
      // console.log("rowClicked", event);

      // 페이지 제목
      this.$store.state.pageTitle += (" > " + event.menu_nm);

      if(event.page_type == "scdul") {
        this.$router.push({name:"scheduleList", query: { menuSno:event.menu_sno }});
      } else {
        this.$router.push({name:"postList", query: { menuSno:event.menu_sno }});
      }
    },

  }
}
</script>
  
<style>

</style>